import { BaseUrl } from "../../../assets/GlobalVariables";

/**
 * קישור לקוח לצפייה בהצעה ציבורית (לא נתיבי דשבורד פנימיים).
 * @param {unknown} token
 * @returns {string}
 */
export function tokenToPublicOfferUrl(token) {
  const t = String(token || "").trim();
  if (!t) return "";
  return `${String(BaseUrl).replace(/\/$/, "")}/offers/public/${encodeURIComponent(t)}`;
}
